/** Мутация изменения паспорта проекта. */
import { useMutation } from "@tanstack/react-query";
import { Api, type UpdateProjectRequest } from "@/api";
import { projectsKeys } from "./keys";

type ProjectPath = { id: string };
type UpdateProjectArgs = [path: ProjectPath, data: UpdateProjectRequest];

export const useUpdateProject = () => {
	const mutation = useMutation({
		mutationFn: ([path, data]: UpdateProjectArgs) => Api.Project.putApiProjectsById(path, data),
		mutationKey: projectsKeys.update,
		networkMode: "always",
	});

	return {
		execute: async (...args: UpdateProjectArgs) => {
			return mutation.mutateAsync(args);
		},
		isPending: mutation.isPending,
	};
};
